// Document extension lists + pure viewability helpers — a LEAF module with zero imports.
//
// These used to live inside SmartDocumentViewer / the 2D/3D viewer implementations, which
// statically pull three.js (~600 KB) and the browser viewers. Light consumers that only
// need "can this extension be previewed?" (Document.jsx, DocumentThumbnail.jsx — both in
// the Monitoring cards' import graph) were dragging the whole 3D stack into their bundle
// chunk. Keep this module import-free so it stays cheap to depend on; the viewer modules
// import the lists FROM here (single source of truth, no cycles).

const extensionConversionMap = {
  step: 'glb',
  stp: 'glb',
  dxf: 'glb'
}

const SmartBrowserDocumentViewerIframeExtensions = ['txt', 'pdf', 'csv']
const SmartBrowserDocumentViewerIframeExtensionsTypes = {
  pdf: 'application/pdf',
  txt: 'text/plain',
  csv: 'text/plain'
}
const SmartBrowserDocumentViewerImageExtensions = ['png', 'gif', 'jpg', 'jpeg', 'bmp', 'svg']
const SmartBrowserDocumentViewerVideoExtensions = ['mp4']
const SmartBrowserDocumentViewerExtensions = [...SmartBrowserDocumentViewerImageExtensions, ...SmartBrowserDocumentViewerVideoExtensions, ...SmartBrowserDocumentViewerIframeExtensions]

const CompatibleModelsExtensions = ['ply', 'obj', 'stl', 'glb']

const checkDocumentExtension = (extension, validList, convertedExtension) => {
  if (!validList) {
    return false
  }
  if (convertedExtension) {
    return validList.includes(convertedExtension)
  }
  if (!extension) {
    return false
  }
  return validList.includes(extension.toLowerCase())
}

const isExtensionViewable = (extension) => {
  if (extension.toLowerCase() in extensionConversionMap) {
    return true
  }
  if (checkDocumentExtension(extension, SmartBrowserDocumentViewerExtensions)) {
    return true
  }
  if (checkDocumentExtension(extension, CompatibleModelsExtensions)) {
    return true
  }
  return false
}

export {
  extensionConversionMap,
  SmartBrowserDocumentViewerIframeExtensions,
  SmartBrowserDocumentViewerIframeExtensionsTypes,
  SmartBrowserDocumentViewerImageExtensions,
  SmartBrowserDocumentViewerVideoExtensions,
  SmartBrowserDocumentViewerExtensions,
  CompatibleModelsExtensions,
  checkDocumentExtension,
  isExtensionViewable
}
